"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findStatusMap = exports.statusMap = exports.EPtwStatus = void 0;
const IUserGroups_1 = require("./IUserGroups");
var EPtwStatus;
(function (EPtwStatus) {
    EPtwStatus[EPtwStatus["NUOVO"] = 0] = "NUOVO";
    EPtwStatus[EPtwStatus["EHS"] = 5] = "EHS";
    EPtwStatus[EPtwStatus["ACCETTAZIONE_R"] = 10] = "ACCETTAZIONE_R";
    EPtwStatus[EPtwStatus["ACCETTAZIONE_N"] = 20] = "ACCETTAZIONE_N";
    EPtwStatus[EPtwStatus["VALUTAZIONE_RICOLLAUDO"] = 30] = "VALUTAZIONE_RICOLLAUDO";
    EPtwStatus[EPtwStatus["ACCETTAZIONE_QUALITA_R"] = 40] = "ACCETTAZIONE_QUALITA_R";
    EPtwStatus[EPtwStatus["CONFERMA_RICOLLAUDO"] = 50] = "CONFERMA_RICOLLAUDO";
    EPtwStatus[EPtwStatus["ACCETTAZIONE_QUALITA_N"] = 60] = "ACCETTAZIONE_QUALITA_N";
    EPtwStatus[EPtwStatus["CONTROLLO_QUALITA_R"] = 70] = "CONTROLLO_QUALITA_R";
    EPtwStatus[EPtwStatus["ACCETTAZIONE_Y"] = 80] = "ACCETTAZIONE_Y";
    EPtwStatus[EPtwStatus["RICOLLAUDO_EXTRA_R"] = 90] = "RICOLLAUDO_EXTRA_R";
    EPtwStatus[EPtwStatus["VERIFICA_COLLAUDO_R"] = 100] = "VERIFICA_COLLAUDO_R";
    EPtwStatus[EPtwStatus["VERIFICA_COLLAUDO"] = 110] = "VERIFICA_COLLAUDO";
    EPtwStatus[EPtwStatus["VERIFICA_QUALITA_R"] = 120] = "VERIFICA_QUALITA_R";
    EPtwStatus[EPtwStatus["CHIUSURA_R"] = 130] = "CHIUSURA_R";
    EPtwStatus[EPtwStatus["CHIUSURA_Y"] = 140] = "CHIUSURA_Y";
    EPtwStatus[EPtwStatus["CANCELLATO"] = 200] = "CANCELLATO";
})(EPtwStatus = exports.EPtwStatus || (exports.EPtwStatus = {}));
exports.statusMap = {
    [EPtwStatus.NUOVO]: {
        roles: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        rolesToNotify: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        next: [EPtwStatus.EHS, EPtwStatus.ACCETTAZIONE_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'New',
    },
    [EPtwStatus.EHS]: {
        roles: [IUserGroups_1.EUserGroup.EHS],
        rolesToNotify: [IUserGroups_1.EUserGroup.EHS],
        next: [EPtwStatus.ACCETTAZIONE_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'EHS',
    },
    [EPtwStatus.ACCETTAZIONE_R]: {
        roles: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        rolesToNotify: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        next: [EPtwStatus.ACCETTAZIONE_N, EPtwStatus.VALUTAZIONE_RICOLLAUDO, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Pending acceptance',
    },
    [EPtwStatus.ACCETTAZIONE_N]: {
        roles: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        rolesToNotify: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        next: [EPtwStatus.ACCETTAZIONE_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Rejected',
    },
    [EPtwStatus.ACCETTAZIONE_QUALITA_N]: {
        roles: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        rolesToNotify: [IUserGroups_1.EUserGroup.PTW_ISSUER, IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        next: [EPtwStatus.ACCETTAZIONE_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Rejected by quality',
    },
    [EPtwStatus.VALUTAZIONE_RICOLLAUDO]: {
        roles: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        rolesToNotify: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        next: [EPtwStatus.ACCETTAZIONE_QUALITA_R, EPtwStatus.CONFERMA_RICOLLAUDO, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Testing impact',
    },
    [EPtwStatus.CONFERMA_RICOLLAUDO]: {
        roles: [IUserGroups_1.EUserGroup.METODISTA],
        rolesToNotify: [IUserGroups_1.EUserGroup.METODISTA],
        next: [EPtwStatus.ACCETTAZIONE_QUALITA_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Re-test required',
    },
    [EPtwStatus.ACCETTAZIONE_QUALITA_R]: {
        roles: [IUserGroups_1.EUserGroup.PQM, IUserGroups_1.EUserGroup.PQM_DELEGATE],
        rolesToNotify: [IUserGroups_1.EUserGroup.PQM, IUserGroups_1.EUserGroup.PQM_DELEGATE],
        next: [EPtwStatus.ACCETTAZIONE_QUALITA_N, EPtwStatus.CONTROLLO_QUALITA_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Pending quality acceptance',
    },
    [EPtwStatus.CONTROLLO_QUALITA_R]: {
        roles: [IUserGroups_1.EUserGroup.PQM, IUserGroups_1.EUserGroup.PQM_DELEGATE],
        rolesToNotify: [IUserGroups_1.EUserGroup.PQM, IUserGroups_1.EUserGroup.PQM_DELEGATE],
        next: [EPtwStatus.ACCETTAZIONE_Y, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Quality impact',
    },
    [EPtwStatus.ACCETTAZIONE_Y]: {
        roles: [IUserGroups_1.EUserGroup.PTW_ISSUER, IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        rolesToNotify: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        sendReminder: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        next: [
            EPtwStatus.RICOLLAUDO_EXTRA_R,
            EPtwStatus.VERIFICA_COLLAUDO_R,
            EPtwStatus.VERIFICA_QUALITA_R,
            EPtwStatus.CHIUSURA_R,
            EPtwStatus.CANCELLATO,
        ],
        editableFields: [],
        name: 'Accepted',
    },
    [EPtwStatus.RICOLLAUDO_EXTRA_R]: {
        roles: [IUserGroups_1.EUserGroup.METODISTA],
        rolesToNotify: [IUserGroups_1.EUserGroup.METODISTA],
        next: [
            EPtwStatus.RICOLLAUDO_EXTRA_R,
            EPtwStatus.VERIFICA_COLLAUDO_R,
            EPtwStatus.VERIFICA_QUALITA_R,
            EPtwStatus.CHIUSURA_R,
            EPtwStatus.CANCELLATO,
        ],
        editableFields: [],
        name: 'Extra work',
    },
    [EPtwStatus.VERIFICA_COLLAUDO_R]: {
        roles: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        rolesToNotify: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        next: [EPtwStatus.VERIFICA_COLLAUDO, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Pending assignment',
    },
    [EPtwStatus.VERIFICA_COLLAUDO]: {
        roles: [IUserGroups_1.EUserGroup.COLLAUDATORE],
        rolesToNotify: [IUserGroups_1.EUserGroup.COLLAUDATORE],
        next: [EPtwStatus.VERIFICA_QUALITA_R, EPtwStatus.CHIUSURA_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Pending re-test',
    },
    [EPtwStatus.VERIFICA_QUALITA_R]: {
        roles: [IUserGroups_1.EUserGroup.QUALITY],
        rolesToNotify: [IUserGroups_1.EUserGroup.QUALITY],
        next: [EPtwStatus.CHIUSURA_R, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Pending quality control',
    },
    [EPtwStatus.CHIUSURA_R]: {
        roles: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        rolesToNotify: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.PRTCM_DELEGATE],
        next: [EPtwStatus.CHIUSURA_Y, EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Pending closure',
    },
    [EPtwStatus.CHIUSURA_Y]: {
        roles: [IUserGroups_1.EUserGroup.PRTCM, IUserGroups_1.EUserGroup.METODISTA],
        rolesToNotify: [IUserGroups_1.EUserGroup.PRTCM],
        next: [EPtwStatus.CANCELLATO],
        editableFields: [],
        name: 'Closed',
    },
    [EPtwStatus.CANCELLATO]: {
        roles: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        rolesToNotify: [IUserGroups_1.EUserGroup.PTW_ISSUER],
        next: [],
        editableFields: [],
        name: 'Deleted',
    },
};
const findStatusMap = (name) => {
    var _a;
    const foundStatuses = [];
    for (const statusMapKey in exports.statusMap) {
        if ((_a = exports.statusMap[statusMapKey].name) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(name === null || name === void 0 ? void 0 : name.toLowerCase())) {
            foundStatuses.push(parseInt(statusMapKey));
        }
    }
    return foundStatuses;
};
exports.findStatusMap = findStatusMap;
